





































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { SurveyStatusResult } from "@/interfaces";
import { AuthModule } from "@/store";

import { date } from "quasar";
import SendSurveyDialog from "@/components/SendSurveyDialog.vue";

@Component
export default class MenuLeft extends Vue {
  @Prop({ type: Boolean, default: () => false })
  value!: boolean;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  toggleMenu() {
    this.$emit("input", !this.value);
  }

  getParsedDate(updated: string) {
    return date.formatDate(updated, "DD/MM/YYYY");
  }

  onSendSurveyClick() {
    this.$q.dialog({
      component: SendSurveyDialog,
      parent: this,
    });
  }
}
